import React, { useEffect, useRef, useState } from 'react'
import { Avatar, Button, Container, Group, Input, InputWrapper, LoadingOverlay, Modal, Stack, Title } from '@mantine/core'
import { Camera } from 'tabler-icons-react';
import getDocument from '../../utils/useFirestoreDocument';
import {
	collection,
	doc,
} from "firebase/firestore";
import { auth, firestore } from '../../firebase';
import { useFirestoreDocumentMutation } from "@react-query-firebase/firestore";
import { useAuthState } from 'react-firebase-hooks/auth';
import useFirebaseFunction from '../../utils/useFirebaseFunction';


const MenuProfile = ({opened,setOpened}) => {
    const { data , isLoading, refetch } = getDocument('users')?.getDocument;

    const [firstName,setFirstName] = useState('');
    const [lastName,setLastName] = useState('');
    const [email,setEmail] = useState('');
    const [website,setWebsite] = useState('');
    const [error,setError] = useState(false);


    const [universal_upload, isUploadLoading] = useFirebaseFunction("universal_upload", "europe-west1");

    useEffect(()=>{
        if(isLoading === false){
            if(data){
                setFirstName(data?.firstName);
                setLastName(data?.lastName);
                setEmail(data?.email);
                setWebsite(data?.website);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[isLoading]);

    function isValidHttpUrl(string) {
        let url;
    
        try {
            url = new URL(string);
        } catch (_) {
            return false;
        }
    
        return url.protocol === "http:" || url.protocol === "https:";
    }

    const [user] = useAuthState(auth);
    const collectionRef = collection(firestore, 'users');
  	const ref = doc(collectionRef, user?.uid || "a");
	const mutationMerge = useFirestoreDocumentMutation(ref, {
		merge: true,
	});

    const avatarRef = useRef(null);
    const userAvatar = getDocument('users')?.getDocument?.data?.avatar;

    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const onClose = () => {
        setFirstName('');
        setLastName('');
        setWebsite('');
        setEmail('');
        setError(false);

        setOpened(false)
    }

    const saveProfile = () => {
        if(firstName?.length < 1) {
            return setError(true);
        };
        if(lastName?.length < 1) {
            return setError(true);
        };
        if(email?.length < 1 || !emailRegex.test(email)) {
            return setError(true);
        };
        if(website?.length > 0) {
            if(!isValidHttpUrl(website)) return {}
        }

        mutationMerge.mutate({
            firstName: firstName,
            lastName: lastName,
            email,
            website: website || '',
            onboarded: 2
		});

        setOpened(false);
    }

    const onChangeAvatar = (e) => {
        if(e.target.files && e.target.files[0]) {
            let fileReader = new FileReader();
            fileReader.readAsDataURL(e.target.files[0]);
            fileReader.onload = (event) => {
                universal_upload({ action: "avatar", image: event.target.result})
            }
        }
    }




    return (
        <Modal
            opened={opened}
            size="md"
            centered={true}
            withCloseButton={false}
            onClose={() => setOpened(false)}
            className="relative"
        >
            <LoadingOverlay visible={isUploadLoading}/>
            <Container size="lg" px={8}>
                <div onClick={() => avatarRef?.current?.click()} className="absolute cursor-pointer -top-[45px] left-1/2 transform -translate-x-1/2">
                    <div className="w-[80px] h-[80px] relative rounded-full">
                        {userAvatar ? 
                            <Avatar style={{borderRadius:'50%',width:'80px',height:'80px'}} src={`https://d2uqrxzbny1jco.cloudfront.net/fit-in/200x200/${userAvatar}`} alt="AvatarUser" />
                        : 
                            (!userAvatar && firstName && lastName 
                            ?
                                <Avatar color="blue" className="uppercase" style={{borderRadius:'50%',width:'80px',height:'80px',fontSize:'25px'}} src={null} alt="AvatarUser">
                                    <span className="text-3xl">{firstName.split('')[0]+lastName.split('')[0]}</span>
                                </Avatar>
                            :
                                <Avatar color="blue" className="uppercase" style={{borderRadius:'50%',width:'80px',height:'80px'}} src={null} alt="AvatarUser" />
                        )}
                        <div style={{backgroundColor:'rgba(11, 11, 11, 0.41)'}} className="absolute w-full h-full rounded-full flex justify-center items-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                            <Camera size={23} color={'white'} />
                        </div>
                    </div>
                </div>
                <input ref={avatarRef} type="file" className="h-0 w-0 invisible" onChange={(e) => onChangeAvatar(e)} />
                <Stack style={{marginTop:'22px'}} align="flex-start">
                    <div className="w-full">
                        <Title align="center" order={1}>Setări profil</Title>
                    </div>
                    <InputWrapper
                        size="md"
                        id="first-name"
                        label="Nume*"
                        error={(firstName?.length < 1 && error) && "Acest camp nu poate fi necompletat"}
                        sx={() => ({
                            width:'100%',
                            maxWidth:'100%',
                        })}
                        >
                        <Input
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            id="first-name"
                            sx={{width:'100%'}}
                        />
                    </InputWrapper>

                    <InputWrapper
                        size="md"
                        id="last-name"
                        label="Prenume*"
                        error={(lastName?.length < 1 && error) && "Acest camp nu poate fi necompletat"}
                        sx={() => ({
                            width:'100%',
                            maxWidth:'100%',
                        })}
                        >
                        <Input
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            id="last-name"
                            sx={{width:'100%'}}
                        />
                    </InputWrapper>

                    <InputWrapper
                        size="md"
                        id="last-name"
                        label="Email*"
                        error={error && (email?.length < 1 || !emailRegex.test(email)) && "Email-ul nu este valid"}
                        sx={() => ({
                            width:'100%',
                            maxWidth:'100%',
                        })}
                    >
                        <Input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            id="email"
                            sx={{width:'100%'}}
                        />
                    </InputWrapper>

                    <InputWrapper
                        size="md"
                        id="website"
                        label="Website"
                        error={(website?.length > 0 && !isValidHttpUrl(website)) && 'Te rugam sa introduci un URL valid'}
                        sx={() => ({
                            width:'100%',
                            maxWidth:'100%',
                        })}
                        >
                        <Input
                            value={website}
                            onChange={(e) => setWebsite(e.target.value)}
                            id="website"
                            sx={{width:'100%'}}
                        />
                    </InputWrapper>
                    <Group style={{width:'100%', marginTop:'20px'}} position="center">
                        <Button onClick={() => onClose()} color="gray">
                            Anuleaza
                        </Button>
                        <Button 
                            onClick={() => saveProfile()}
                        >
                            Salveaza
                        </Button>
                    </Group>
                </Stack>
            </Container>
        </Modal>
    )
}

export default MenuProfile